import { SoundConfigSchema } from "slotworks/config/sound-config-schema";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import Contract from "slotworks/utils/contracts/contract";

/**
 * DEPRECATED. Use Services.sound instead
 */
export class SoundManager {

    public get onMuteChange() {
        return Services.sound.onMuteChange;
    }

    public get onLoadComplete() {
        return Services.sound.onLoadComplete;
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public init(soundConfig: SoundConfigSchema) {
        Services.sound.init(soundConfig);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public setSoundSprite(sound: Howl, definiton: IHowlSoundSpriteDefinition) {
        Services.sound.setSoundSprite(sound, definiton);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public customEventContract(event: string): Contract<void> {
        return Services.sound.customEventContract(event);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public customEvent(event: string) {
        Services.sound.customEvent(event);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public event(event: SoundEvent, ...args: string[]) {
        Services.sound.event(event, ...args);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public setLoading() {
        Services.sound.setLoading();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public getLoading() {
        return Services.sound.getLoading();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public mute() {
        Services.sound.mute();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public unmute() {
        Services.sound.unmute();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public setSoundFxMute(mute: boolean) {
        Services.sound.setSoundFxMute(mute);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public setMusicMute(mute: boolean) {
        Services.sound.setMusicMute(mute);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public getMuted() {
        return Services.sound.getMuted();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public getSoundFxMuted() {
        return Services.sound.getSoundFxMuted();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public getMusicMuted() {
        return Services.sound.getMusicMuted();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public setVolume(volume: number) {
        Services.sound.setVolume(volume);
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public getVolume() {
        return Services.sound.getVolume();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public focus() {
        Services.sound.focus();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public unfocus() {
        Services.sound.unfocus();
    }

    /**
     * DEPRECATED. Use Services.sound instead
     */
    public isMutePreferenceSet() {
        return Services.sound.isMutePreferenceSet();
    }
}

export default new SoundManager();
